<div class="ws-chip" [ngStyle]="getChipStyles()">
  <span class="chip-label">{{ label }}</span>
  <ng-content></ng-content>
</div>
